import type { TextFormFieldFragment } from "../../client/generated";
import { TextPredictionButton } from "./TextPredictionButton";
import { useTranslation } from "react-i18next";
import { FormField, FormLabel } from "@acdc2/ui/components/access-form";
import { EditorContent, Editor } from "@tiptap/react";
import { RichTextToolbar } from "../../rich-text/RichTextToolbar";
import { Separator } from "@acdc2/ui/components/separator";
import { AccessLoading } from "@acdc2/ui/components/access-loading";

type Props = {
  fragment: TextFormFieldFragment;
  editor: Editor | null;
};

export function TextFormField({ fragment, editor }: Props) {
  const { t } = useTranslation();

  if (!editor) {
    return <AccessLoading />;
  }

  return (
    <FormField name="text">
      <FormLabel>{t("TextFormField.label")}</FormLabel>
      <div className="rounded-md border">
        <RichTextToolbar fragment={fragment.page} editor={editor} />
        <Separator decorative />
        <EditorContent editor={editor} />
      </div>
      <TextPredictionButton
        fragment={fragment}
        onAccept={(prediction) => editor.commands.setContent(prediction)}
      />
    </FormField>
  );
}
